import { extractShortLanguage } from './extractShortLanguage';

interface IPrepareLanguageResult {
  shortLanguage: string;
  shortDefaultLanguage: string;
}

export function prepareLanguages(language = '', defaultLanguage = ''): IPrepareLanguageResult {
  return {
    shortLanguage: extractShortLanguage(language),
    shortDefaultLanguage: extractShortLanguage(defaultLanguage),
  };
}
